// #region imports

// --- Angular
import { Component, EventEmitter, Output } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-self-register-widget',
  templateUrl: './self-register-widget.component.html',
  styleUrls: ['./self-register-widget.component.scss']
})
export class SelfRegisterWidgetComponent {
  @Output() registerClicked = new EventEmitter<string>();

  onWidgetButtonClick(eventName: string): void {
    this.registerClicked.emit(eventName);
  }
}
